import { render } from "./ActionButton.vue?vue&type=template&id=495bbc65&scoped=true&ts=true"
import script from "./ActionButton.vue?vue&type=script&lang=ts"
export * from "./ActionButton.vue?vue&type=script&lang=ts"

import "@/components/Shared/ActionButton/style.scss?vue&type=style&index=0&id=495bbc65&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495bbc65"]])

export default __exports__